import { Avatar, styled, Typography, useTheme } from "@mui/material";
import CheckIcon from "assets/icons/CheckIcon";
import { formatPrice, getDefaultCurrency } from "../../helpers";
import { useDispatch, useSelector } from "react-redux";
import { parseLocaleNumber } from "components/openingBalance/helpers";
import searchForProductImg from "assets/images/searchForProduct.jpg";
import { apiSetBankTransactionApproved } from "api/reportApi";

const PriceComponentContainer = styled("span")({
  display: "inline-flex",
  direction: "rtl",
});

export const PriceComponent = (props: { value: string; item: any; options?: any, col?: any }) => {
  const { value, item } = props;
  const colInfo = props.col
  const business = useSelector((state: any) => state).businessReducer.business;
  const { currencies } = useSelector((state: any) => state).currencyReducer;

  const defaultCurrency = getDefaultCurrency(business.business.default_currency_id, currencies);
  const currentCurrency = item.currency ? item.currency.en_title : defaultCurrency.en_title;
  const theme = useTheme();

  if (value === "-") return "0";
  const haveCurrency = item.currency && item.currency.en_title !== defaultCurrency.en_title;
  const Price = ({ val, currency }: { val: string | number; currency: string }) => {
    return (
      <div style={{ display: "flex", gap: "5px", width: "100%", justifyContent: "start", direction: "rtl" }}>
        <Typography
          color={theme.palette.disabled.contrastText}
          variant="body2"
          style={{ width: "30px", textAlign: "center" }}
        >
          {currency}
        </Typography>
        <Typography style={{ direction: "ltr", textAlign: "end" }} variant="body2">
          <span
            style={{
              color:
                (props?.options?.colored || colInfo.colored) && val ? (parseLocaleNumber(val) > 0 ? "#24AF22" : "#CB0B0B") : "",
            }}
          >
            {formatPrice(val)}
          </span>
        </Typography>
      </div>
    );
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      <Price currency={item.currency_amount ? defaultCurrency.en_title : currentCurrency} val={value} />
      {props?.options?.withCurrency && haveCurrency && !!value && item.currency_amount && (
        <Price currency={currentCurrency} val={item.currency_amount} />
      )}
    </div>
  );
};

export const PriceComponentColored = (props: { value: string; item: any }) => {
  return PriceComponent({ ...props, options: { colored: true } });
};

export const PriceComponentWithCurrency = (props: { value: string; item: any }) => {
  return PriceComponent({ ...props, options: { withCurrency: true } });
};

export const CheckComponent = ({ value }: { value: string }) => {
  if (value === "-") return "-";
  return <CheckIcon />;
};

export const AmountComponent = ({ value, item }: { value: string; item: any }) => {
  const theme = useTheme();
  if (value === "-") return "-";
  return (
    <PriceComponentContainer className="flex items-center gap-2">
      <Typography className="text-dark-3 text-xs">{item?.unit || "عدد"}</Typography>
      <Typography className="text-dark-1 text-sm" style={{ direction: "ltr" }}>
        {value}
      </Typography>
    </PriceComponentContainer>
  );
};

export const StatusComponent = ({ value }: { value: string }) => {
  if (value === "-") return "-";
  const bgColor = value !== "ناموفق" ? "#E7F5E9" : "#FFEAF0";
  const color = value !== "ناموفق" ? "#24AF22" : "#CB0B0B";
  return (
    <div
      className="rounded-full flex justify-center items-center text-xs py-1 px-2"
      style={{ backgroundColor: bgColor || "", color: color || "" }}
    >
      {value}
    </div>
  );
};

export const Approvement = ({ item, col }: { item: any; value: string; col: any }) => {
  const store = useSelector((state: any) => state);
  const dispatch: any = useDispatch();
  const token = store.businessReducer.business?.token;
  const req = col.reqUrl || apiSetBankTransactionApproved;

  const approved = item?.approved;
  const bgColor = approved ? "#E7F5E9" : "#FFEAF0";
  const color = approved ? "#24AF22" : "#CB0B0B";

  function handleClick() {
    dispatch(req({ id: item.id, approved: !item.approved, token }));
  }

  return (
    <div
      className="cursor-pointer"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleClick();
      }}
    >
      <div
        className="rounded-full flex justify-center items-center text-xs py-1 px-2 w-20"
        style={{ backgroundColor: bgColor || "", color: color || "" }}
      >
        {approved ? "تایید شده" : "بررسی نشده"}
      </div>
    </div>
  );
};

export const NumberComponent = ({ value }: { value: string }) => {
  if (value === "-") return "-";
  return <div style={{ direction: "ltr" }}>{value}</div>;
};

const EmptyTableContainer = styled("div")({
  display: "flex",
  height: "300px",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  flexDirection: "column",
});

export const StyledAvatar = styled(Avatar)(({ theme }: { theme?: ThemeObjType }) => ({
  width: "100px",
  height: "120px",
  borderRadius: theme?.shape.borderRadius || "none",
  // border: outLine ? `2px solid ${theme?.palette.disabled.main || 'none'}` : 'none'
}));

export const EmptyTable = ({ error }: { error: string }) => {
  const theme = useTheme();
  return (
    <EmptyTableContainer>
      <StyledAvatar src={searchForProductImg} />
      <div style={{ padding: "10px" }}></div>
      <Typography>{error}</Typography>
    </EmptyTableContainer>
  );
};
